import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autoload-modal"
export default class extends Controller {
  connect() {
    const dataSet = this.element.dataset
    const { autoloadModalEnabled, autoloadModalPath } = dataSet

    if (autoloadModalEnabled === 'true'){
      Turbo.visit(autoloadModalPath, {
        frame: 'modal-portal'
      })
    }
  }
}
